export default __webpack_public_path__ + "static/media/shop_website.2eba94d5.svg";